import angular from 'angular';
import 'angular-ui-router';
import {map} from 'lodash';
import template from './gameDevelopersForm.jade';

export class GameDevelopersFormController {
  /* @ngInject */
  constructor(countryCodesOptions, currencyOptions, $filter, currentUser) {
    this.translate = $filter('translate');
    this.currentUser = currentUser;
    currentUser.subscribe(user => this.user = user);

    this.fields = [
      {
        className: 'layout__item u-1/1',
        type: 'input',
        key: 'company_name',
        expressionProperties: {
          "templateOptions.label": "'company_name' | translate"
        },
        templateOptions: {
          label: '',
          required: true
        }
      },
      {
        className: 'layout__item u-1/1',
        type: 'input',
        key: 'street_address',
        expressionProperties: {
          "templateOptions.label": "'street_address' | translate"
        },
        templateOptions: {
          label: '',
          required: true
        }
      },
      {
        "fieldGroup": [
          {
            className: 'layout__item u-6/12',
            type: 'input',
            key: 'city',
            expressionProperties: {
              "templateOptions.label": "'city' | translate"
            },
            templateOptions: {
              label: '',
              required: true
            }
          },
          {
            className: 'layout__item u-3/12',
            type: 'input',
            key: 'state',
            expressionProperties: {
              "templateOptions.label": "'state' | translate"
            },
            templateOptions: {
              label: ''
            }
          },
          {
            className: 'layout__item u-3/12',
            type: 'input',
            key: 'zipcode',
            expressionProperties: {
              "templateOptions.label": "'zipcode' | translate"
            },
            templateOptions: {
              label: '',
              required: true
            }
          }
        ]
      },
      {
        "fieldGroup": [
          {
            className: 'layout__item u-6/12',
            type: 'uiSelect',
            key: 'country_code',
            expressionProperties: {
              "templateOptions.label": "'country_code' | translate"
            },
            templateOptions: {
              label: '',
              options: countryCodesOptions,
              required: true
            }
          },
          {
            className: 'layout__item u-6/12',
            type: 'input',
            key: 'vat_number',
            expressionProperties: {
              "templateOptions.label": "'optional_field' | translateWith:'vat'"
            },
            templateOptions: {
              label: ''
            }
          }
        ]
      },
      {
        className: 'layout__item u-3/12',
        type: 'uiSelect',
        key: 'currency',
        expressionProperties: {
          "templateOptions.label": "'currency' | translate",
          "templateOptions.disabled": (($viewValue, $modelValue, scope) => {
            return this.user.hasRole('APP_DEVELOPER');
          })
        },
        templateOptions: {
          label: '',
          options: currencyOptions,
          required: true,
          onChange: (($newValue, $model, $scope) => {
            let origCurrency = this.resource.origCurrency;
            if ($model && $newValue != origCurrency) {
              if (!confirm(this.translate('confirmChangingCurrency'))) {
                this.resource.currency = this.resource.origCurrency;
              }
            }
          })
        }
      },
      {
        className: 'layout__item u-1/1',
        type: 'input',
        key: 'website',
        expressionProperties: {
          "templateOptions.label": "'website' | translate"
        },
        templateOptions: {
          label: '',
          required: true,
          type: 'url'
        }
      },
      {
        className: 'layout__item u-1/1',
        expressionProperties: {
          "templateOptions.label": "'store_extended_cohort_dimensions' | translate"
        },
        type: 'checkbox',
        key: 'store_extended_cohort_dimensions',
      },
      {
        className: 'layout__item u-1/1',
        expressionProperties: {
          "templateOptions.label": "'agency' | translate"
        },
        type: 'checkbox',
        key: 'agency_checkbox',
      },
      {
        className: 'layout__item u-1/1',
        type: 'input',
        key: 'agency',
        hideExpression: (() => !this.resource.agency_checkbox),
        templateOptions: {
          label: `${this.translate('agency')}`,
          required: true
        }
      },
    ];

    this.fields = map(this.fields, ({className, ...rest}) => ({
      className: this.withDisabledClassName(className),
      ...rest
    }));
  };

  withDisabledClassName(className) {
    return this.currentUser.value.hasRole(['AGENCY','GD_ACCOUNT_MANAGER','GG_ACCOUNT_MANAGER']) ? `${className} disabled-by-role` : className;
  };
}

export function GameDevelopersFormComponent() {
  return {
    template,
    controller: GameDevelopersFormController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      resource: '='
    },
    bindToController: true
  };
};

export default angular.module('app.components.admin.gameDevelopers.form', [])
  .directive('gameDevelopersForm', GameDevelopersFormComponent);



/** WEBPACK FOOTER **
 ** ./src/components/admin/gameDevelopers/gameDevelopersForm.js
 **/